import React, { FC } from "react";
import { useSelector } from "react-redux";

import { ImportFile } from "./ImportFile";
import { ImportMeta } from "./ImportMeta";
import { GDBImportFinish } from "./GDBImportFinish";
import { useImportContext } from "../importContext";
import { ImportLayers } from "./ImportLayers";
import { ImportTarget } from "./ImportTarget";
import { getLocation } from "../../../../ducks/location/selectors";
import { GDBImportFromLayersStep, GDBImportFromPanelStep, GDBImportFromProjectsStep } from "../types";
import { RoutePanelName } from "../../../../appConfig/types";

export const GDBImportSteps: FC = () => {
  const { step } = useImportContext();
  const location = useSelector(getLocation);

  // Из контекстного меню TOC
  if (location.payload.panel === RoutePanelName.Layers || location.payload.panel === RoutePanelName.Table) {
    switch (step) {
      case GDBImportFromPanelStep.Layers:
        return <ImportLayers />;
      case GDBImportFromPanelStep.Finish:
        return <GDBImportFinish />;
      default:
        return <ImportFile />;
    }
  }

  // Из каталога из вкладки "Слои"
  if (location.payload.tab === RoutePanelName.Layers) {
    switch (step) {
      case GDBImportFromLayersStep.Layers:
        return <ImportLayers />;
      case GDBImportFromLayersStep.Target:
        return <ImportTarget />;
      case GDBImportFromLayersStep.Finish:
        return <GDBImportFinish />;
      default:
        return <ImportFile />;
    }
  }

  // Из каталога из вкладки "Проекты"
  if (location.payload.tab === "projects") {
    switch (step) {
      case GDBImportFromProjectsStep.Layers:
        return <ImportLayers />;
      case GDBImportFromProjectsStep.Meta:
        return <ImportMeta />;
      case GDBImportFromProjectsStep.Finish:
        return <GDBImportFinish />;
      default:
        return <ImportFile />;
    }
  }
};
